import axios from 'axios';
import get from 'lodash/get';
import { put, call, cancelled } from 'redux-saga/effects';
import http from '@api/http';
import * as types from './types';

export default function* autoRequest(index, func, type, payload, autoCancel = true) {
  yield put({
    type: `${type}${types.SET_PAYLOAD}`,
    index,
    payload,
  });
  const source = axios.CancelToken.source();
  try {
    const response = yield call(func, payload, { cancelToken: source.token }, http);
    yield put({ type: `${type}${types.FETCHING_SUCCESS}`, index });
    yield put({
      type: `${type}${types.SET_RESPONSE}`,
      index,
      response,
    });
    return response;
  } catch (error) {
    yield put({
      type: `${type}${types.FETCHING_FAIL}`,
      index,
      errorCode: get(error, 'code', 500),
      errorMsg: get(error, 'response.data.message', 'Unknown Error'),
    });
    throw error;
  } finally {
    if (yield cancelled() && autoCancel) {
      source.cancel();
      yield put({ type: `${type}${types.ABORT_FETCHING}`, index });
    }
  }
}
